import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LcsFormsModule } from '@lcs/shared/forms';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsProgressButtonModule } from '@lcs/shared/progress-button';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CallStateModule } from 'src/app/call-state/call-state.module';
import { NdtLogoModule } from 'src/app/common-components/ndt-logo/ndt-logo.module';
import { PasswordFormControlModule } from 'src/app/common-components/password-form-control/password-form-control.module';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AccountVerificationComponent } from './containers/account-verification.component';
import { AccountVerificationEffects } from './state/account-verification.effects';
import * as fromAccountVerification from './state/account-verification.reducer';
import { AccountVerificationViewComponent } from './views/account-verification-view.component';

@NgModule({
   declarations: [AccountVerificationComponent, AccountVerificationViewComponent],
   imports: [
      CallStateModule,
      CommonModule,
      FormsModule,
      MatInputModule,
      MatFormFieldModule,
      MatButtonModule,
      LcsFormsModule,
      ReactiveFormsModule,
      NdtLogoModule,
      LcsProgressButtonModule,
      LcsLoadingOverlayModule,
      PasswordFormControlModule,
      StoreModule.forFeature(fromAccountVerification.accountVerificationFeatureKey, fromAccountVerification.reducer),
      EffectsModule.forFeature([AccountVerificationEffects]),
   ],
})
export class AccountVerificationModule {}
